import { Context } from '#store/overmind';

export const toggleMainMenu = (
  { state }: Context,
  open: boolean | undefined
) => {
  state.app.mainMenuOpen =
    typeof open !== 'undefined' ? !!open : !state.app.mainMenuOpen;
};

export const toggleProfileMenu = ({ state }: Context, open: boolean) => {
  state.app.profileMenuOpen =
    open !== null ? !!open : !state.app.profileMenuOpen;
};

export const setIsLoadingIndicatorVisible = (
  { state }: Context,
  visible: boolean
) => {
  state.app.isLoadingIndicatorVisible = visible;
};

export const initSearchQuery = ({ state }: Context, query: string) => {
  state.search.query = query;
};

export const toggleSearch = ({ state }: Context, open: boolean) => {
  state.app.searchOpen =
    open !== null && typeof open !== 'undefined'
      ? !!open
      : !state.app.searchOpen;
};

export const toggleAccordionPanel = ({ state }: Context, panel: string) => {
  let active = true;
  if (state.app.activePanel) {
    if (state.app.activePanel.accordionPanel === panel) {
      active = !state.app.activePanel.active;
    }
  }
  state.app.activePanel = { accordionPanel: panel, active };
};

export const showProfileSelection = ({ state }: Context) => {
  state.app.profileSelectionVisible = true;
};

export const hideProfileSelection = ({ state }: Context) => {
  state.app.profileSelectionVisible = false;
};
